// https://heroicons.dev/

export const moreOptionsIcon = (
  <svg
    data-slot="icon"
    fill="none"
    strokeWidth="1.5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM18.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
    ></path>
  </svg>
);

export const expandIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    className="h-4 w-4"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15"
    />
  </svg>
);

export const minimiseIcon = (
  <svg
    width="30"
    height="30"
    strokeWidth={1.3}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25 6.25H1.75M6.25 6.25V1.75M6.25 6.25L1 1"
      stroke="currentColor"
    />
    <path
      d="M6.25 12L6.25 16.5M6.25 12L1.75 12M6.25 12L1 17.25"
      stroke="currentColor"
    />
    <path
      d="M12 12L16.5 12M12 12L12 16.5M12 12L17.25 17.25"
      stroke="currentColor"
    />
    <path
      d="M12 6.25L12 1.75M12 6.25L16.5 6.25M12 6.25L17.25 1"
      stroke="currentColor"
    />
  </svg>
);

export const shrinkIcon = (
  <svg
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.5 7.5h-.75A2.25 2.25 0 004.5 9.75v7.5a2.25 2.25 0 002.25 2.25h7.5a2.25 2.25 0 002.25-2.25v-7.5a2.25 2.25 0 00-2.25-2.25h-.75m-6 3.75l3 3m0 0l3-3m-3 3V1.5m6 9h.75a2.25 2.25 0 012.25 2.25v7.5a2.25 2.25 0 01-2.25 2.25h-7.5a2.25 2.25 0 01-2.25-2.25v-.75"
    ></path>
  </svg>
);

export const viewIcon = `<svg
    width="20"
    height="9"
    strokeWidth="1.5
     stroke="currentColor"
    viewBox="0 0 148 67"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M147.259 30.3943C127.814 10.7938 101.902 0 74.2922 0C74.2258 0 74.1619 0.00511036 74.0955 0.00511036C74.0623 0.00511036 74.0316 0 74.001 0C73.909 0 73.8196 0.012771 73.7303 0.012771C46.3319 0.158357 20.6372 10.9266 1.32786 30.3943L0.740408 30.9869C-0.253155 31.9881 -0.245492 33.6049 0.755733 34.5985C1.25379 35.0914 1.9051 35.3392 2.55385 35.3392C3.21027 35.3392 3.86924 35.0863 4.3673 34.5831L4.95475 33.9906C18.3512 20.4868 34.9864 11.4094 53.1157 7.42235C45.6091 13.514 40.7971 22.8034 40.7971 33.2039C40.7971 51.512 55.6929 66.4078 74.001 66.4078C92.3091 66.4078 107.205 51.512 107.205 33.2039C107.205 22.691 102.28 13.3224 94.6334 7.2359C113.09 11.1233 130.029 20.2799 143.632 33.9931C144.626 34.9969 146.245 35.002 147.244 34.0085C148.245 33.0123 148.253 31.3956 147.259 30.3943ZM102.097 33.2013C102.097 48.6922 89.4919 61.297 74.001 61.297C58.5101 61.297 45.9054 48.6922 45.9054 33.2013C45.9054 17.8024 58.3645 5.26665 73.7277 5.11851C73.8503 5.11851 73.9729 5.11085 74.0955 5.11085C89.543 5.16449 102.097 17.7437 102.097 33.2013Z"
      fill="currentColor"
    />
  </svg>`;

// export const contextMenuEditIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path fill-rule="evenodd" clip-rule="evenodd" d="M22.4197 0.963027C21.1356 -0.321007 19.0538 -0.321011 17.7697 0.963027L2.25308 16.4797C1.79407 16.9387 1.4812 17.5233 1.3539 18.1597L0.710473 21.3769C0.403717 22.9106 1.756 24.263 3.28978 23.9562L6.5069 23.3128C7.14342 23.1855 7.72802 22.8726 8.18703 22.4136L23.7036 6.89696C24.9877 5.61293 24.9877 3.5311 23.7036 2.24706L22.4197 0.963027ZM19.3197 2.51299C19.7477 2.08498 20.4416 2.08498 20.8697 2.51299L22.1537 3.79703C22.5818 4.22504 22.5818 4.91898 22.1537 5.347L19.2256 8.27504L16.3917 5.44103L19.3197 2.51299ZM14.8416 6.99101L3.80304 18.0296C3.65004 18.1826 3.54576 18.3775 3.50332 18.5897L2.8599 21.8068L6.07701 21.1633C6.28919 21.1209 6.48406 21.0167 6.63706 20.8637L17.6757 9.82501L14.8416 6.99101Z" fill="#0F0F0F"/>
// </svg>
// `;

export const contextMenuEditIcon = `  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7_7)">
      <path
        d="M12.9 6.858L17.142 11.101L7.242 21H3V16.757L12.9 6.857V6.858ZM14.314 5.444L16.435 3.322C16.6225 3.13453 16.8768 3.02921 17.142 3.02921C17.4072 3.02921 17.6615 3.13453 17.849 3.322L20.678 6.151C20.8655 6.33853 20.9708 6.59284 20.9708 6.858C20.9708 7.12316 20.8655 7.37747 20.678 7.565L18.556 9.686L14.314 5.444Z"
        fill="currentColor"
      />
    </g>
  </svg>`;

export const newWindowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    className="h-4 w-4"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
    />
  </svg>
);

export const newWindowIconForRightClick = `  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    className="h-4 w-4"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
    />
  </svg>`;

export const close = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 13L13 1M1 1L13 13" stroke="currentColor" />
  </svg>
);

export const favouriteStar = (
  <svg
    fill="none"
    height="8"
    width="8"
    version="1.1"
    id="Layer_1"
    viewBox="0 0 512 512"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <g>
        <g>
          <path
            stroke="currentColor"
            fill="currentColor"
            d="M511.177,197.119c-1.975-6.079-7.23-10.51-13.554-11.429l-156.54-22.758L271.059,21.066 c-2.829-5.731-8.667-9.359-15.059-9.359c-6.391,0-12.23,3.628-15.059,9.359l-70.024,141.866L14.377,185.689 c-6.324,0.919-11.58,5.35-13.554,11.429c-1.976,6.079-0.328,12.753,4.25,17.214L118.338,324.74L91.619,480.664 c-1.08,6.3,1.51,12.665,6.681,16.422c5.17,3.756,12.024,4.252,17.683,1.279l140.016-73.593l140.014,73.593 c5.688,2.99,12.54,2.457,17.683-1.279c5.171-3.756,7.762-10.123,6.681-16.422L393.66,324.741l113.267-110.409 C511.505,209.87,513.153,203.196,511.177,197.119z M363.897,306.851c-3.958,3.857-5.763,9.414-4.83,14.861l22.463,131.097 l-117.718-61.875c-4.89-2.572-10.735-2.573-15.625,0l-117.719,61.875l22.463-131.097c0.934-5.446-0.872-11.004-4.83-14.861 L52.878,214.03l131.607-19.133c5.469-0.795,10.195-4.23,12.643-9.185L256,66.439l58.872,119.274 c2.447,4.955,7.174,8.39,12.643,9.185l131.607,19.133L363.897,306.851z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const closeSM = (
  <svg
    width="8"
    height="8"
    viewBox="0 0 14 14"
    strokeWidth="2"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 13L13 1M1 1L13 13" stroke="currentColor" />
  </svg>
);

export const notifications = (
  <svg
    width="18"
    height="22"
    viewBox="0 0 18 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 18V16H3V9C3 7.61667 3.41667 6.3875 4.25 5.3125C5.08333 4.2375 6.16667 3.53333 7.5 3.2V2.5C7.5 2.08333 7.64583 1.72917 7.9375 1.4375C8.22917 1.14583 8.58333 1 9 1C9.41667 1 9.77083 1.14583 10.0625 1.4375C10.3542 1.72917 10.5 2.08333 10.5 2.5V3.2C11.8333 3.53333 12.9167 4.2375 13.75 5.3125C14.5833 6.3875 15 7.61667 15 9V16H17V18H1ZM9 21C8.45 21 7.97917 20.8042 7.5875 20.4125C7.19583 20.0208 7 19.55 7 19H11C11 19.55 10.8042 20.0208 10.4125 20.4125C10.0208 20.8042 9.55 21 9 21ZM5 16H13V9C13 7.9 12.6083 6.95833 11.825 6.175C11.0417 5.39167 10.1 5 9 5C7.9 5 6.95833 5.39167 6.175 6.175C5.39167 6.95833 5 7.9 5 9V16Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.025"
    />
  </svg>
);

export const closeLg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    strokeWidth="2"
    width="25"
    height="25"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);

export const pin = (
  <svg
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
    ></path>
  </svg>
);

export const flag = (
  <svg
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.5 10.5V6.75a4.5 4.5 0 119 0v3.75M3.75 21.75h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H3.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
    ></path>
  </svg>
);

export const plus = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

export const plusForRightClick = `
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    className="h-4 w-4"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
`;

export const exportFullTrade = `<svg
    fill="none"
    strokeWidth="1.5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m.75 12 3 3m0 0 3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
    ></path>
  </svg>`;

export const squarePlus = (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 0C5.63261 0 5.75979 0.0526785 5.85355 0.146447C5.94732 0.240215 6 0.367392 6 0.5V5H10.5C10.6326 5 10.7598 5.05268 10.8536 5.14645C10.9473 5.24021 11 5.36739 11 5.5C11 5.63261 10.9473 5.75979 10.8536 5.85355C10.7598 5.94732 10.6326 6 10.5 6H6V10.5C6 10.6326 5.94732 10.7598 5.85355 10.8536C5.75979 10.9473 5.63261 11 5.5 11C5.36739 11 5.24021 10.9473 5.14645 10.8536C5.05268 10.7598 5 10.6326 5 10.5V6H0.5C0.367392 6 0.240215 5.94732 0.146447 5.85355C0.0526785 5.75979 0 5.63261 0 5.5C0 5.36739 0.0526785 5.24021 0.146447 5.14645C0.240215 5.05268 0.367392 5 0.5 5H5V0.5C5 0.367392 5.05268 0.240215 5.14645 0.146447C5.24021 0.0526785 5.36739 0 5.5 0Z"
      fill="currentColor"
    />
  </svg>
);

export const squarePlusSM = (
  <svg
    width="10"
    height="10"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7 2V12M2 7H12" stroke="currentColor" strokeWidth="1" />
  </svg>
);

export const saveIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="saveIconTitle"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="square"
    strokeLinejoin="miter"
    fill="none"
    color="currentColor"
  >
    <path d="M17.2929,3.29289 L21,7 L21,20 C21,20.5523 20.5523,21 20,21 L4,21 C3.44772,21 3,20.5523 3,20 L3,4 C3,3.44772 3.44772,3 4,3 L16.5858,3 C16.851,3 17.1054,3.10536 17.2929,3.29289 Z"></path>
    <rect width="10" height="8" x="7" y="13"></rect>
    <rect width="8" height="5" x="8" y="3"></rect>
  </svg>
);

export const editPencil = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        stroke="currentColor"
        d="M15.728 9.686l-1.414-1.414L5 17.586V19h1.414l9.314-9.314zm1.414-1.414l1.414-1.414-1.414-1.414-1.414 1.414 1.414 1.414zM7.242 21H3v-4.243L16.435 3.322a1 1 0 0 1 1.414 0l2.829 2.829a1 1 0 0 1 0 1.414L7.243 21z"
      />
    </g>
  </svg>
);

export const refreshArrow = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="2"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.992 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182M2.985 14.652"
    />
  </svg>
);

export const resetIcon = (
  <svg
    data-slot="icon"
    fill="none"
    strokeWidth="1.5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 0 1-1.125-1.125v-3.75ZM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-8.25ZM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-2.25Z"
    ></path>
  </svg>
);

export const clearWorkspaceIcon = (
  <svg
    data-slot="icon"
    fill="none"
    strokeWidth="1.5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.25 7.5A2.25 2.25 0 0 1 7.5 5.25h9a2.25 2.25 0 0 1 2.25 2.25v9a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25v-9Z"
    ></path>
  </svg>
);

export const pencil = (
  <svg
    width="13"
    height="13"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"
    ></path>
  </svg>
);

// Plus icon matching pencil style (HeroIcons)
export const plusFill = (
  <svg
    width="15"
    height="15"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 4.5v15m7.5-7.5h-15"
    ></path>
  </svg>
);

// Close/X icon matching pencil style (HeroIcons)
export const closeFill = (
  <svg
    width="15"
    height="15"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 18L18 6M6 6l12 12"
    ></path>
  </svg>
);

// AG Grid side bar rail icon for the Prices Views panel (a string, as AG Grid icons are).
export const viewsRailIcon =
  '<svg fill="none" stroke="currentColor" stroke-width="1.5" width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
  '<rect x="3.75" y="3.75" width="16.5" height="16.5" rx="2" />' +
  '<path stroke-linecap="round" d="M3.75 9h16.5M9 9v11.25" />' +
  "</svg>";

export const copyIcon = (
  <svg
    width="15"
    height="15"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75"
    />
  </svg>
);

export const checkIcon = (
  <svg
    width="14"
    height="14"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
  </svg>
);

export const searchIcon = (
  <svg
    width="14"
    height="14"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
    />
  </svg>
);

export const trashBin = (
  <svg
    width="15"
    height="15"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    ></path>
  </svg>
);

export const send = (
  <svg
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5"
    ></path>
  </svg>
);

export const settingsIcon = (
  <svg
    fill="none"
    stroke="currentColor"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99376 3.97917C10.0875 3.41458 10.5771 3 11.15 3H13.851C14.424 3 14.9135 3.41458 15.0073 3.97917L15.2292 5.31354C15.2948 5.70313 15.5552 6.02812 15.901 6.21979C15.9781 6.26146 16.0542 6.30625 16.1302 6.35208C16.4688 6.55625 16.8802 6.61979 17.25 6.48125L18.5177 6.00625C18.7775 5.90855 19.0635 5.90623 19.3249 5.9997C19.5862 6.09317 19.8059 6.27637 19.9448 6.51667L21.2948 8.85729C21.4334 9.09761 21.4822 9.3793 21.4327 9.65226C21.3831 9.92521 21.2382 10.1717 21.024 10.3479L19.9792 11.2094C19.674 11.4604 19.5229 11.8479 19.5313 12.2427C19.5327 12.3312 19.5327 12.4198 19.5313 12.5083C19.5229 12.9021 19.674 13.2896 19.9792 13.5406L21.025 14.4021C21.4667 14.7667 21.5813 15.3969 21.2958 15.8917L19.9438 18.2323C19.8051 18.4725 19.5856 18.6558 19.3245 18.7494C19.0634 18.8431 18.7775 18.8411 18.5177 18.7437L17.25 18.2688C16.8802 18.1302 16.4688 18.1937 16.1292 18.3979C16.0537 18.4439 15.9773 18.4883 15.9 18.5312C15.5552 18.7219 15.2948 19.0469 15.2292 19.4365L15.0073 20.7708C14.9135 21.3365 14.424 21.75 13.851 21.75H11.149C10.576 21.75 10.0875 21.3354 9.99271 20.7708L9.77084 19.4365C9.70626 19.0469 9.44584 18.7219 9.10001 18.5302C9.02276 18.4876 8.94636 18.4435 8.87084 18.3979C8.5323 18.1937 8.12084 18.1302 7.75001 18.2688L6.4823 18.7437C6.22264 18.8412 5.93684 18.8433 5.67573 18.7499C5.41462 18.6564 5.19512 18.4734 5.05626 18.2333L3.70521 15.8927C3.56661 15.6524 3.51776 15.3707 3.56736 15.0977C3.61695 14.8248 3.76177 14.5783 3.97605 14.4021L5.02188 13.5406C5.32605 13.2906 5.47709 12.9021 5.4698 12.5083C5.46817 12.4198 5.46817 12.3312 5.4698 12.2427C5.47709 11.8469 5.32605 11.4604 5.02188 11.2094L3.97605 10.3479C3.76203 10.1718 3.61737 9.92545 3.56779 9.65273C3.5182 9.38001 3.5669 9.09855 3.70521 8.85833L5.05626 6.51771C5.19499 6.27723 5.4146 6.09381 5.67596 6.00014C5.93731 5.90647 6.22343 5.90864 6.48334 6.00625L7.75001 6.48125C8.12084 6.61979 8.5323 6.55625 8.87084 6.35208C8.94584 6.30625 9.02292 6.2625 9.10001 6.21875C9.44584 6.02813 9.70626 5.70313 9.77084 5.31354L9.99376 3.97917Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M15.625 12.5C15.625 13.3288 15.2958 14.1237 14.7097 14.7097C14.1237 15.2958 13.3288 15.625 12.5 15.625C11.6712 15.625 10.8763 15.2958 10.2903 14.7097C9.70424 14.1237 9.375 13.3288 9.375 12.5C9.375 11.6712 9.70424 10.8763 10.2903 10.2903C10.8763 9.70424 11.6712 9.375 12.5 9.375C13.3288 9.375 14.1237 9.70424 14.7097 10.2903C15.2958 10.8763 15.625 11.6712 15.625 12.5Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

// String (HTML) variant of `settingsIcon` for AG Grid context menus, which take
// an HTML string for `icon` rather than a JSX element.
// LQC-2576 - "Off-load Risk" right-click item: blocks re-created in the opposite direction.
export const offloadRiskForRightClick = `
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    className="h-4 w-4"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"
    />
  </svg>
`;

export const expiryClockForRightClick = `
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    width="16"
    height="16"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M12 6v6l4 2m6-2a10 10 0 1 1-20 0 10 10 0 0 1 20 0Z"
    />
  </svg>
`;

export const returnToLiveTradesForRightClick = `
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    width="16"
    height="16"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3"
    />
  </svg>
`;

export const settingsIconForRightClick = `
  <svg
    fill="none"
    stroke="currentColor"
    width="18"
    height="18"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99376 3.97917C10.0875 3.41458 10.5771 3 11.15 3H13.851C14.424 3 14.9135 3.41458 15.0073 3.97917L15.2292 5.31354C15.2948 5.70313 15.5552 6.02812 15.901 6.21979C15.9781 6.26146 16.0542 6.30625 16.1302 6.35208C16.4688 6.55625 16.8802 6.61979 17.25 6.48125L18.5177 6.00625C18.7775 5.90855 19.0635 5.90623 19.3249 5.9997C19.5862 6.09317 19.8059 6.27637 19.9448 6.51667L21.2948 8.85729C21.4334 9.09761 21.4822 9.3793 21.4327 9.65226C21.3831 9.92521 21.2382 10.1717 21.024 10.3479L19.9792 11.2094C19.674 11.4604 19.5229 11.8479 19.5313 12.2427C19.5327 12.3312 19.5327 12.4198 19.5313 12.5083C19.5229 12.9021 19.674 13.2896 19.9792 13.5406L21.025 14.4021C21.4667 14.7667 21.5813 15.3969 21.2958 15.8917L19.9438 18.2323C19.8051 18.4725 19.5856 18.6558 19.3245 18.7494C19.0634 18.8431 18.7775 18.8411 18.5177 18.7437L17.25 18.2688C16.8802 18.1302 16.4688 18.1937 16.1292 18.3979C16.0537 18.4439 15.9773 18.4883 15.9 18.5312C15.5552 18.7219 15.2948 19.0469 15.2292 19.4365L15.0073 20.7708C14.9135 21.3365 14.424 21.75 13.851 21.75H11.149C10.576 21.75 10.0875 21.3354 9.99271 20.7708L9.77084 19.4365C9.70626 19.0469 9.44584 18.7219 9.10001 18.5302C9.02276 18.4876 8.94636 18.4435 8.87084 18.3979C8.5323 18.1937 8.12084 18.1302 7.75001 18.2688L6.4823 18.7437C6.22264 18.8412 5.93684 18.8433 5.67573 18.7499C5.41462 18.6564 5.19512 18.4734 5.05626 18.2333L3.70521 15.8927C3.56661 15.6524 3.51776 15.3707 3.56736 15.0977C3.61695 14.8248 3.76177 14.5783 3.97605 14.4021L5.02188 13.5406C5.32605 13.2906 5.47709 12.9021 5.4698 12.5083C5.46817 12.4198 5.46817 12.3312 5.4698 12.2427C5.47709 11.8469 5.32605 11.4604 5.02188 11.2094L3.97605 10.3479C3.76203 10.1718 3.61737 9.92545 3.56779 9.65273C3.5182 9.38001 3.5669 9.09855 3.70521 8.85833L5.05626 6.51771C5.19499 6.27723 5.4146 6.09381 5.67596 6.00014C5.93731 5.90647 6.22343 5.90864 6.48334 6.00625L7.75001 6.48125C8.12084 6.61979 8.5323 6.55625 8.87084 6.35208C8.94584 6.30625 9.02292 6.2625 9.10001 6.21875C9.44584 6.02813 9.70626 5.70313 9.77084 5.31354L9.99376 3.97917Z"
      stroke="currentColor"
      stroke-width="2"
    />
    <path
      d="M15.625 12.5C15.625 13.3288 15.2958 14.1237 14.7097 14.7097C14.1237 15.2958 13.3288 15.625 12.5 15.625C11.6712 15.625 10.8763 15.2958 10.2903 14.7097C9.70424 14.1237 9.375 13.3288 9.375 12.5C9.375 11.6712 9.70424 10.8763 10.2903 10.2903C10.8763 9.70424 11.6712 9.375 12.5 9.375C13.3288 9.375 14.1237 9.70424 14.7097 10.2903C15.2958 10.8763 15.625 11.6712 15.625 12.5Z"
      stroke="currentColor"
      stroke-width="2"
    />
  </svg>
`;

export const leftArrowWhite = (
  <svg
    width="10"
    height="10"
    viewBox="0 0 29 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.585786 13.5858C-0.195262 14.3668 -0.195262 15.6332 0.585786 16.4142L13.3137 29.1421C14.0948 29.9232 15.3611 29.9232 16.1421 29.1421C16.9232 28.3611 16.9232 27.0948 16.1421 26.3137L4.82843 15L16.1421 3.68629C16.9232 2.90524 16.9232 1.63891 16.1421 0.857864C15.3611 0.0768158 14.0948 0.0768158 13.3137 0.857864L0.585786 13.5858ZM29 13L2 13V17L29 17V13Z"
      fill="white"
    />
  </svg>
);

export const leftArrowBlack = (
  <svg
    width="10"
    height="10"
    viewBox="0 0 29 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.585786 13.5858C-0.195262 14.3668 -0.195262 15.6332 0.585786 16.4142L13.3137 29.1421C14.0948 29.9232 15.3611 29.9232 16.1421 29.1421C16.9232 28.3611 16.9232 27.0948 16.1421 26.3137L4.82843 15L16.1421 3.68629C16.9232 2.90524 16.9232 1.63891 16.1421 0.857864C15.3611 0.0768158 14.0948 0.0768158 13.3137 0.857864L0.585786 13.5858ZM29 13L2 13V17L29 17V13Z"
      fill="#141414"
    />
  </svg>
);

export const rightArrowWhite = (
  <svg
    width="10"
    height="10"
    viewBox="0 0 29 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.4142 16.4142C29.1953 15.6332 29.1953 14.3668 28.4142 13.5858L15.6863 0.857864C14.9052 0.0768158 13.6389 0.0768158 12.8579 0.857864C12.0768 1.63891 12.0768 2.90524 12.8579 3.68629L24.1716 15L12.8579 26.3137C12.0768 27.0948 12.0768 28.3611 12.8579 29.1421C13.6389 29.9232 14.9052 29.9232 15.6863 29.1421L28.4142 16.4142ZM0 17L27 17V13L0 13L0 17Z"
      fill="white"
    />
  </svg>
);

export const rightArrowBlack = (
  <svg
    width="10"
    height="10"
    viewBox="0 0 29 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.4142 16.4142C29.1953 15.6332 29.1953 14.3668 28.4142 13.5858L15.6863 0.857864C14.9052 0.0768158 13.6389 0.0768158 12.8579 0.857864C12.0768 1.63891 12.0768 2.90524 12.8579 3.68629L24.1716 15L12.8579 26.3137C12.0768 27.0948 12.0768 28.3611 12.8579 29.1421C13.6389 29.9232 14.9052 29.9232 15.6863 29.1421L28.4142 16.4142ZM0 17L27 17V13L0 13L0 17Z"
      fill="#141414"
    />
  </svg>
);

export const openToolbarIcon = (
  // SINGEL CHEV
  <svg
    width="20"
    height="20"
    data-slot="icon"
    fill="none"
    strokeWidth="1.5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m8.25 4.5 7.5 7.5-7.5 7.5"
    ></path>
  </svg>
);

export const closeToolbarIcon = (
  // SINGLE CHEV
  <svg
    width="20"
    height="20"
    data-slot="icon"
    fill="none"
    strokeWidth="1.5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.75 19.5 8.25 12l7.5-7.5"
    ></path>
  </svg>
);

export const editIcon = (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7_7)">
      <path
        d="M12.9 6.858L17.142 11.101L7.242 21H3V16.757L12.9 6.857V6.858ZM14.314 5.444L16.435 3.322C16.6225 3.13453 16.8768 3.02921 17.142 3.02921C17.4072 3.02921 17.6615 3.13453 17.849 3.322L20.678 6.151C20.8655 6.33853 20.9708 6.59284 20.9708 6.858C20.9708 7.12316 20.8655 7.37747 20.678 7.565L18.556 9.686L14.314 5.444Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const calendarIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.75 2.25H14.75C14.9489 2.25 15.1397 2.32902 15.2803 2.46967C15.4209 2.61032 15.5 2.80109 15.5 3V15C15.5 15.1989 15.4209 15.3897 15.2803 15.5303C15.1397 15.6709 14.9489 15.75 14.75 15.75H1.25C1.05109 15.75 0.860323 15.6709 0.719668 15.5303C0.57902 15.3897 0.5 15.1989 0.5 15V3C0.5 2.80109 0.57902 2.61032 0.719668 2.46967C0.860323 2.32902 1.05109 2.25 1.25 2.25H4.25V0.75H5.75V2.25H10.25V0.75H11.75V2.25ZM14 6.75V3.75H11.75V5.25H10.25V3.75H5.75V5.25H4.25V3.75H2V6.75H14ZM14 8.25H2V14.25H14V8.25ZM3.5 9.75H7.25V12.75H3.5V9.75Z"
      fill="#FAFAFA"
    />
  </svg>
);

export const auth0IconSVG = (
  <svg
    width="300"
    height="64"
    viewBox="0 0 300 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M69.4472 45.1602L79.4013 19.0701H83.2377L93.1533 45.1602H89.6896L86.9327 38.1172H75.5649L72.8081 45.1602H69.4472ZM85.956 35.174L81.2199 22.6109L76.5224 35.174H85.956Z"
      fill="black"
    />
    <path
      d="M107.548 26.1517H110.607V45.1602H107.959L107.548 42.6283C106.43 44.0421 104.605 45.3851 101.475 45.3851C97.2981 45.3851 93.9822 43.0396 93.9822 36.7355V26.1517H97.0411V36.5492C97.0411 40.5013 98.8275 42.5898 101.996 42.5898C105.459 42.5898 107.548 39.9422 107.548 35.656V26.1517Z"
      fill="black"
    />
    <path
      d="M112.072 28.9471V26.1517H115.503V20.8244H118.562V26.1517H123.485V28.9471H118.562V40.1671C118.562 41.7672 119.121 42.3648 120.76 42.3648H123.78V45.1602H120.464C116.814 45.1602 115.51 43.5601 115.51 40.2057V28.9471H112.072Z"
      fill="black"
    />
    <path
      d="M142.474 34.5764V45.1602H139.415V34.7627C139.415 30.8107 137.513 28.7222 134.236 28.7222C130.695 28.7222 128.497 31.3697 128.497 35.656V45.1602H125.438V19.0701H128.497V29.2812C129.615 27.4948 131.556 25.9268 134.756 25.9268C139.004 25.9268 142.467 28.2723 142.467 34.5764H142.474Z"
      fill="black"
    />
    <path
      d="M144.601 31.5175C144.601 24.1018 148.624 18.8452 154.516 18.8452C160.409 18.8452 164.393 24.1018 164.393 31.5175V32.7128C164.393 40.5013 160.371 45.3851 154.516 45.3851C148.662 45.3851 144.601 40.5013 144.601 32.7128V31.5175ZM161.225 31.6268C161.225 25.4384 158.539 21.7112 154.516 21.7112C150.494 21.7112 147.769 25.4384 147.769 31.6268V32.5971C147.769 38.7855 150.455 42.5126 154.516 42.5126C158.578 42.5126 161.225 38.7855 161.225 32.5971V31.6268Z"
      fill="black"
    />
    <path
      d="M195.438 35.656C195.438 41.4716 191.563 45.3851 186.307 45.3851C183.1 45.3851 180.941 44.0806 179.784 42.2556L179.373 45.1602H176.725V19.0701H179.784V29.2105C181.05 27.4562 183.1 25.9332 186.307 25.9332C191.563 25.9332 195.438 29.474 195.438 35.6624V35.656ZM192.309 35.656C192.309 31.5175 189.777 28.6515 186.011 28.6515C182.245 28.6515 179.752 31.524 179.752 35.5853C179.752 39.6466 182.284 42.6669 186.011 42.6669C189.738 42.6669 192.309 39.7944 192.309 35.6624V35.656Z"
      fill="black"
    />
    <path
      d="M195.322 26.1517H198.568L204.422 41.3238L210.09 26.1517H213.335L204.576 48.3669C203.381 51.4257 202.674 52.6145 199.994 52.6145H196.344V49.8192H199.062C200.817 49.8192 201.112 49.3693 201.819 47.5829L202.751 45.2695L195.335 26.1517H195.322Z"
      fill="black"
    />
    <path
      d="M236.173 45.3851C228.828 45.3851 223.726 39.7944 223.726 32.1152C223.726 24.4359 228.835 18.8452 236.173 18.8452C243.512 18.8452 248.621 24.4359 248.621 32.1152C248.621 39.7944 243.512 45.3851 236.173 45.3851ZM236.173 42.4034C241.616 42.4034 245.305 38.1172 245.305 32.1152C245.305 26.1131 241.616 21.8269 236.173 21.8269C230.73 21.8269 227.042 26.1131 227.042 32.1152C227.042 38.1172 230.73 42.4034 236.173 42.4034Z"
      fill="black"
    />
    <path
      d="M250.966 19.0701H254.025V36.2536L263.568 26.1517H267.334L259.918 34.0173L267.854 45.1602H264.166L257.868 36.215L254.032 40.1671V45.1602H250.973V19.0701H250.966Z"
      fill="black"
    />
    <path
      d="M268.105 28.9471V26.1517H271.536V20.8244H274.595V26.1517H279.518V28.9471H274.595V40.1671C274.595 41.7672 275.154 42.3648 276.793 42.3648H279.813V45.1602H276.497C272.847 45.1602 271.543 43.5601 271.543 40.2057V28.9471H268.105Z"
      fill="black"
    />
    <path
      d="M299.439 42.3648V45.1602H297.761C295.23 45.1602 294.368 44.0806 294.33 42.217C293.135 43.9328 291.239 45.3851 287.955 45.3851C283.778 45.3851 280.951 43.2966 280.951 39.8329C280.951 36.0287 283.598 33.9081 288.591 33.9081H294.182V32.6035C294.182 30.1423 292.428 28.6515 289.446 28.6515C286.76 28.6515 284.973 29.9174 284.601 31.8581H281.542C281.992 28.131 285.006 25.9332 289.594 25.9332C294.439 25.9332 297.234 28.3559 297.234 32.7899V41.0989C297.234 42.1078 297.607 42.3648 298.462 42.3648H299.439ZM288.296 36.4785C285.577 36.4785 284.048 37.4874 284.048 39.6466C284.048 41.5102 285.648 42.7761 288.186 42.7761C291.991 42.7761 294.188 40.5784 294.188 37.4103V36.4785H288.296Z"
      fill="black"
    />
    <path
      d="M3.37163 27.7823C13.8466 26.0536 22.0585 17.3818 23.7786 6.88966L24.3558 1.84681C24.4986 1.04545 23.9557 -0.0707301 22.9442 0.00940596C15.0295 0.627599 7.56046 3.24347 3.40592 4.9435C1.34294 5.79065 0 7.79405 0 10.0264V26.4772C0 27.4503 0.874338 28.1944 1.8344 28.0399L3.37163 27.788V27.7823Z"
      fill="black"
    />
    <path
      d="M28.8312 6.89002C30.557 17.3821 38.7689 26.054 49.2381 27.7826L50.7753 28.0345C51.7354 28.1948 52.6097 27.4507 52.6097 26.4718V10.0211C52.6097 7.78869 51.2668 5.78529 49.2038 4.93814C45.0436 3.23238 37.5803 0.622239 29.6655 0.00404612C28.6483 -0.07609 28.1282 1.05154 28.2483 1.84145L28.8254 6.8843L28.8312 6.89002Z"
      fill="black"
    />
    <path
      d="M49.2301 32.3907C34.915 35.2184 28.2689 44.7488 28.2689 62.7909C28.2689 63.6953 29.166 64.3249 29.9204 63.8212C36.5036 59.3737 50.9902 47.7654 52.4818 33.2436C52.5389 31.4176 50.2588 32.2762 49.2301 32.3907Z"
      fill="black"
    />
    <path
      d="M3.37691 32.3907C17.6921 35.2184 24.3382 44.7488 24.3382 62.7909C24.3382 63.6953 23.441 64.3249 22.6867 63.8212C16.1034 59.3737 1.6168 47.7654 0.125285 33.2436C0.0681382 31.4176 2.34828 32.2762 3.37691 32.3907Z"
      fill="black"
    />
  </svg>
);
export const auth0IconSVGLight = (
  <svg
    width="150"
    height="48"
    viewBox="0 0 158 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M41.5215 30.4292L46.1277 18.3525H47.9047L52.4936 30.4292H50.8891L49.6124 27.1684H44.3509L43.0742 30.4292H41.5215ZM44.7995 25.8054H49.1645L46.9734 19.9916L44.7995 25.8054Z"
      fill="#FFFFFF"
    ></path>
    <path
      d="M59.1609 21.6309H60.5756V30.4295H59.3506L59.1609 29.2563C58.6433 29.9119 57.7979 30.533 56.3487 30.533C54.4164 30.533 52.8809 29.4464 52.8809 26.5307V21.6309H54.2956V26.4444C54.2956 28.2729 55.1237 29.2393 56.5902 29.2393C58.1947 29.2393 59.1609 28.0144 59.1609 26.0303V21.6309Z"
      fill="#FFFFFF"
    ></path>
    <path
      d="M62.8389 22.9242H61.252V21.6302H62.8389V19.1631H64.2536V21.6302H66.531V22.9242H64.2536V28.1173C64.2536 28.8589 64.5124 29.1352 65.2715 29.1352H66.669V30.4292H65.1335C63.4428 30.4292 62.8389 29.6873 62.8389 28.1345V22.9242Z"
      fill="#FFFFFF"
    ></path>
    <path
      d="M75.3279 25.5294V30.4292H73.9131V25.6157C73.9131 23.7872 73.0333 22.8207 71.515 22.8207C69.876 22.8207 68.8581 24.0454 68.8581 26.0294V30.4289H67.4434V18.3525H68.8581V23.0798C69.3757 22.2517 70.2728 21.5268 71.7565 21.5268C73.7234 21.5268 75.3279 22.6137 75.3279 25.5294Z"
      fill="#FFFFFF"
    ></path>
    <path
      d="M76.6426 24.115C76.6426 20.6817 78.5059 18.249 81.2315 18.249C83.9402 18.249 85.8035 20.6817 85.8035 24.115V24.6671C85.8035 28.2726 83.9402 30.5327 81.2315 30.5327C78.5059 30.5327 76.6426 28.2726 76.6426 24.6671V24.115ZM84.337 24.1667C84.337 21.3028 83.0948 19.5775 81.2315 19.5775C79.3513 19.5775 78.1091 21.3028 78.1091 24.1667V24.6153C78.1091 27.4793 79.3513 29.2045 81.2315 29.2045C83.0951 29.2045 84.337 27.4793 84.337 24.6153V24.1667Z"
      fill="#FFFFFF"
    ></path>
    <path
      d="M100.174 26.0297C100.174 28.7212 98.38 30.5327 95.9473 30.5327C94.4636 30.5327 93.4629 29.9292 92.9284 29.0838L92.7383 30.4292H91.5137V18.3525H92.9284V23.045C93.515 22.2338 94.4636 21.5268 95.9473 21.5268C98.3797 21.5268 100.174 23.1661 100.174 26.0297ZM98.7247 26.0297C98.7247 24.1147 97.5515 22.7865 95.809 22.7865C94.0837 22.7865 92.9106 24.115 92.9106 25.9955C92.9106 27.9275 94.0837 29.2736 95.809 29.2736C97.5515 29.2733 98.7247 27.9448 98.7247 26.0297Z"
      fill="#FFFFFF"
    ></path>
    <path
      d="M100.119 21.6307H101.62L104.329 28.6523L106.951 21.6307H108.452L104.398 31.9131C103.846 33.3278 103.518 33.8796 102.276 33.8796H100.585V32.5857H101.844C102.655 32.5857 102.793 32.3786 103.121 31.5505L103.552 30.4808L100.119 21.6307Z"
      fill="#FFFFFF"
    ></path>
    <path
      d="M119.026 30.5334C115.627 30.5334 113.264 27.9458 113.264 24.3917C113.264 20.8379 115.627 18.25 119.026 18.25C122.425 18.25 124.788 20.8379 124.788 24.3917C124.788 27.9455 122.425 30.5334 119.026 30.5334ZM119.026 29.1532C121.545 29.1532 123.253 27.1691 123.253 24.3914C123.253 21.6137 121.545 19.6296 119.026 19.6296C116.507 19.6296 114.799 21.6137 114.799 24.3914C114.799 27.1691 116.507 29.1532 119.026 29.1532Z"
      fill="#FFFFFF"
    ></path>
    <path
      d="M126.201 18.3525H127.616V26.3058L132.033 21.6303H133.775L130.342 25.2703L134.017 30.4289H132.309L129.393 26.2882L127.616 28.117V30.4286H126.201V18.3525H126.201Z"
      fill="#FFFFFF"
    ></path>
    <path
      d="M135.722 22.9242H134.135V21.6302H135.722V19.1631H137.137V21.6302H139.414V22.9242H137.137V28.1173C137.137 28.8589 137.395 29.1352 138.155 29.1352H139.552V30.4292H138.016C136.326 30.4292 135.722 29.6873 135.722 28.1345V22.9242Z"
      fill="#FFFFFF"
    ></path>
    <path
      d="M148.637 29.1358V30.4298H147.861C146.688 30.4298 146.291 29.9294 146.274 29.0668C145.722 29.8604 144.842 30.5333 143.324 30.5333C141.391 30.5333 140.08 29.5671 140.08 27.9626C140.08 26.2028 141.305 25.2194 143.617 25.2194H146.205V24.6156C146.205 23.4772 145.394 22.7871 144.014 22.7871C142.772 22.7871 141.943 23.3737 141.771 24.2708H140.356C140.563 22.5453 141.961 21.5273 144.083 21.5273C146.326 21.5273 147.62 22.6491 147.62 24.7019V28.5492C147.62 29.0151 147.792 29.1361 148.189 29.1361L148.637 29.1358ZM146.205 26.4099H143.479C142.22 26.4099 141.512 26.8757 141.512 27.8764C141.512 28.739 142.254 29.3256 143.427 29.3256C145.187 29.3256 146.205 28.3077 146.205 26.8412V26.4099H146.205Z"
      fill="#FFFFFF"
    ></path>
    <path
      d="M10.9416 22.3882C15.7991 21.588 19.6037 17.5722 20.4038 12.7177L20.6716 10.3826C20.737 10.0108 20.4871 9.49616 20.0171 9.53185C16.3465 9.81741 12.887 11.0281 10.9565 11.8164C10.0016 12.206 9.37695 13.1371 9.37695 14.1693V21.7843C9.37695 22.2364 9.7815 22.5785 10.2277 22.5071L10.9416 22.3911V22.3882Z"
      fill="#FFFFFF"
    ></path>
    <path
      d="M22.7455 12.7149C23.5457 17.5725 27.3502 21.5853 32.2078 22.3854L32.9217 22.5014C33.3679 22.5758 33.7724 22.2308 33.7724 21.7786V14.1636C33.7724 13.1314 33.1477 12.2033 32.1929 11.8107C30.2653 11.0224 26.8029 9.81172 23.1322 9.52616C22.6622 9.49046 22.4183 10.011 22.4748 10.3769L22.7425 12.712L22.7455 12.7149Z"
      fill="#FFFFFF"
    ></path>
    <path
      d="M32.2044 24.5181C25.568 25.8269 22.4863 30.2383 22.4863 38.591C22.4863 39.0105 22.9028 39.299 23.2508 39.067C26.3028 37.0085 33.0194 31.6364 33.7125 24.9137C33.7393 24.066 32.6803 24.4646 32.2044 24.5181Z"
      fill="#FFFFFF"
    ></path>
    <path
      d="M10.9439 24.5182C17.5803 25.827 20.662 30.2384 20.662 38.5911C20.662 39.0105 20.2455 39.299 19.8975 39.067C16.8456 37.0086 10.1289 31.6364 9.4358 24.9138C9.40903 24.066 10.468 24.4646 10.9439 24.5182Z"
      fill="#FFFFFF"
    ></path>
  </svg>
);

export const grabHandSVGDark = (
  <svg
    data-testid="grab-hand-svg-dark"
    fill="#FFFFFF"
    width="15px"
    height="15px"
    viewBox="0 0 36 36"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>cursor-hand-grab-line</title>
    <path
      d="M28.09,9.74a4,4,0,0,0-1.16.19c-.19-1.24-1.55-2.18-3.27-2.18A4,4,0,0,0,22.13,8,3.37,3.37,0,0,0,19,6.3a3.45,3.45,0,0,0-2.87,1.32,3.65,3.65,0,0,0-1.89-.51A3.05,3.05,0,0,0,11,9.89v.91c-1.06.4-4.11,1.8-4.91,4.84s.34,8,2.69,11.78a25.21,25.21,0,0,0,5.9,6.41.9.9,0,0,0,.53.17H25.55a.92.92,0,0,0,.55-.19,13.13,13.13,0,0,0,3.75-6.13A25.8,25.8,0,0,0,31.41,18v-5.5A3.08,3.08,0,0,0,28.09,9.74ZM29.61,18a24,24,0,0,1-1.47,9.15A12.46,12.46,0,0,1,25.2,32.2H15.47a23.75,23.75,0,0,1-5.2-5.72c-2.37-3.86-3-8.23-2.48-10.39A5.7,5.7,0,0,1,11,12.76v7.65a.9.9,0,0,0,1.8,0V9.89c0-.47.59-1,1.46-1s1.49.52,1.49,1v5.72h1.8V8.81c0-.28.58-.71,1.46-.71s1.53.48,1.53.75v6.89h1.8V10l.17-.12a2.1,2.1,0,0,1,1.18-.32c.93,0,1.5.44,1.5.68l0,6.5H27V11.87a1.91,1.91,0,0,1,1.12-.33c.86,0,1.52.51,1.52.94Z"
      className="clr-i-outline clr-i-outline-path-1"
    ></path>
  </svg>
);

export const grabHandSVGLight = (
  <svg
    data-testid="grab-hand-svg-light"
    fill="#000000"
    width="15px"
    height="15px"
    viewBox="0 0 36 36"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>cursor-hand-grab-line</title>
    <path
      d="M28.09,9.74a4,4,0,0,0-1.16.19c-.19-1.24-1.55-2.18-3.27-2.18A4,4,0,0,0,22.13,8,3.37,3.37,0,0,0,19,6.3a3.45,3.45,0,0,0-2.87,1.32,3.65,3.65,0,0,0-1.89-.51A3.05,3.05,0,0,0,11,9.89v.91c-1.06.4-4.11,1.8-4.91,4.84s.34,8,2.69,11.78a25.21,25.21,0,0,0,5.9,6.41.9.9,0,0,0,.53.17H25.55a.92.92,0,0,0,.55-.19,13.13,13.13,0,0,0,3.75-6.13A25.8,25.8,0,0,0,31.41,18v-5.5A3.08,3.08,0,0,0,28.09,9.74ZM29.61,18a24,24,0,0,1-1.47,9.15A12.46,12.46,0,0,1,25.2,32.2H15.47a23.75,23.75,0,0,1-5.2-5.72c-2.37-3.86-3-8.23-2.48-10.39A5.7,5.7,0,0,1,11,12.76v7.65a.9.9,0,0,0,1.8,0V9.89c0-.47.59-1,1.46-1s1.49.52,1.49,1v5.72h1.8V8.81c0-.28.58-.71,1.46-.71s1.53.48,1.53.75v6.89h1.8V10l.17-.12a2.1,2.1,0,0,1,1.18-.32c.93,0,1.5.44,1.5.68l0,6.5H27V11.87a1.91,1.91,0,0,1,1.12-.33c.86,0,1.52.51,1.52.94Z"
      className="clr-i-outline clr-i-outline-path-1"
    ></path>
  </svg>
);

export const workspaceIcon = (
  <svg
    width="23"
    height="23"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.4"
      y="0.4"
      width="12.2"
      height="12.6194"
      rx="3.6"
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <rect
      x="13.4"
      y="0.4"
      width="12.2"
      height="12.6194"
      rx="3.6"
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <rect
      x="13.4"
      y="12.9806"
      width="12.2"
      height="12.6194"
      rx="3.6"
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <rect
      x="0.4"
      y="12.9806"
      width="12.2"
      height="12.6194"
      rx="3.6"
      stroke="currentColor"
      strokeWidth="1.2"
    />
  </svg>
);

export const activeWorkspaceIcon = (
  <svg
    width="26"
    height="26"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.4"
      y="0.4"
      width="12.2"
      height="12.6194"
      rx="3.6"
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <rect
      x="15.4"
      y="0.4"
      width="10.2"
      height="10.2"
      rx="3.6"
      fill="#FF7700"
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <rect
      x="13.4"
      y="12.9806"
      width="12.2"
      height="12.6194"
      rx="3.6"
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <rect
      x="0.4"
      y="12.9806"
      width="12.2"
      height="12.6194"
      rx="3.6"
      stroke="currentColor"
      strokeWidth="1.2"
    />
  </svg>
);

export const myCubeIcon = (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    // xmlns:xlink="http://www.w3.org/1999/xlink"
    width="23px"
    height="23px"
    viewBox="0 12.875 50 41.635"
    enableBackground="new 0 12.875 50 41.635"
    // xml:space="preserve"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0" />

    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <g id="SVGRepo_iconCarrier">
      <g id="Layer_3"> </g>
      <g id="Layer_2">
        <g>
          <polygon
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="25.331,36.012 2.571,25.035 25.209,14.178 47.97,25.156 "
          />
        </g>
        <g>
          <path
            fill="none"
            stroke="#f0a338"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M40.883,30.362l7.087,3.419L25.331,44.637 L2.571,33.66c0,0,3.909-1.873,7.012-3.361"
          />
        </g>
        <g>
          <polyline
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="41.229,39.155 47.97,42.406 25.331,53.262 2.571,42.285 9.081,39.164 "
          />
        </g>
      </g>
    </g>
  </svg>
);

export const actievMyCubeIcon = (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    // xmlns:xlink="http://www.w3.org/1999/xlink"
    width="23px"
    height="23px"
    viewBox="0 12.875 50 41.635"
    enableBackground="new 0 12.875 50 41.635"
    // xml:space="preserve"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0" />

    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <g id="SVGRepo_iconCarrier">
      <g id="Layer_3"> </g>
      <g id="Layer_2">
        <g>
          <polygon
            fill="#FF7700"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="25.331,36.012 2.571,25.035 25.209,14.178 47.97,25.156 "
          />
        </g>
        <g>
          <path
            fill="none"
            stroke="#f0a338"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M40.883,30.362l7.087,3.419L25.331,44.637 L2.571,33.66c0,0,3.909-1.873,7.012-3.361"
          />
        </g>
        <g>
          <polyline
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="41.229,39.155 47.97,42.406 25.331,53.262 2.571,42.285 9.081,39.164 "
          />
        </g>
      </g>
    </g>
  </svg>
);

export const helpdeskHelp = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 14H12L15 17V14H17V6H15M1 1H12V9H6L3 12V9H1V1Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// ---- START: ---- baseWidgetDetails: IbaseWidgetDetails[]
export const widgetActionSummary: JSX.Element = (
  <svg
    data-slot="icon"
    fill="none"
    strokeWidth="1.5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25"
    ></path>
  </svg>
  // <svg
  //   data-slot="icon"
  //   fill="none"
  //   strokeWidth="1.5"
  //   stroke="currentColor"
  //   viewBox="0 0 24 24"
  //   xmlns="http://www.w3.org/2000/svg"
  //   aria-hidden="true"
  // >
  //   <path
  //     strokeLinecap="round"
  //     strokeLinejoin="round"
  //     d="m21 7.5-9-5.25L3 7.5m18 0-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9"
  //   ></path>
  // </svg>
);
export const widgetTradeCreation: JSX.Element = (
  <svg
    data-slot="icon"
    fill="none"
    strokeWidth="1.5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 18v-5.25m0 0a6.01 6.01 0 0 0 1.5-.189m-1.5.189a6.01 6.01 0 0 1-1.5-.189m3.75 7.478a12.06 12.06 0 0 1-4.5 0m3.75 2.383a14.406 14.406 0 0 1-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 1 0-7.517 0c.85.493 1.509 1.333 1.509 2.316V18"
    ></path>
  </svg>
);

export const widgetAxeCreation: JSX.Element = (
  <svg
    width="23"
    height="26"
    viewBox="0 0 23 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    // stroke="currentColor"
  >
    <path
      d="M12.8264 8.08418L7.8275 15.9771L7.64561 16.2734C6.75819 17.7701 6.18358 19.433 5.95715 21.1607L5.83403 22.1034L5.82025 22.1744C5.80232 22.2444 5.77098 22.3105 5.72809 22.3692C5.67154 22.4466 5.59608 22.5079 5.50933 22.5485C5.42156 22.5915 5.32401 22.6123 5.22648 22.6064C5.12976 22.6005 5.03654 22.569 4.95508 22.5165L4.95456 22.5174L2.05379 20.6802L10.8315 6.82074L12.8264 8.08418Z"
      stroke="currentColor"
      strokeWidth="0.3"
    />
    <path
      d="M16.1328 2.86353L15.7075 3.5351L13.7126 2.27166L14.1379 1.6001L16.1328 2.86353Z"
      stroke="currentColor"
      strokeWidth="0.3"
    />
    <path
      d="M16.7167 2.35489C16.8333 2.42884 16.9154 2.54665 16.9457 2.6814C16.9759 2.81618 16.9513 2.95725 16.8774 3.07394L16.4944 3.67868L17.2584 4.16253L21.8285 5.7785L22.0061 5.84126L17.6008 12.797L17.4681 12.6633L14.0538 9.22236L13.2909 8.73687L8.46336 16.3592C7.52803 17.8411 6.92566 19.509 6.6985 21.2466L6.69932 21.2471L6.57045 22.1989L6.56963 22.1984C6.5415 22.4183 6.45892 22.6281 6.32842 22.8074C6.19789 22.9865 6.02377 23.1295 5.82315 23.2237C5.62254 23.3179 5.40158 23.36 5.1804 23.3461C5.01428 23.3355 4.85177 23.2939 4.70206 23.2234L4.5574 23.1434L1.47101 21.1887C1.35426 21.1147 1.27094 20.9973 1.24067 20.8624C1.21052 20.7277 1.23512 20.5865 1.30895 20.4699L10.0412 6.68221L8.80367 5.89844L12.0088 0.837778L13.2463 1.62155L13.6293 1.01681C13.7032 0.900184 13.8203 0.81764 13.955 0.78729C14.0898 0.75702 14.2321 0.78133 14.3489 0.855272L16.7167 2.35489ZM2.46827 20.5869L5.11658 22.2641C5.15503 22.2891 5.19915 22.3033 5.24489 22.3061C5.29069 22.3089 5.33664 22.3007 5.37786 22.2805L5.38025 22.2785L5.38108 22.2791C5.42277 22.2598 5.45839 22.2297 5.48552 22.1926C5.5127 22.1554 5.53 22.1117 5.53566 22.066L5.53618 22.0652L5.65983 21.1216C5.90729 19.2336 6.56128 17.4213 7.57732 15.8108L12.4132 8.17522L10.9257 7.23313L2.46827 20.5869ZM16.7865 5.08091L16.7704 5.07533L12.3376 2.26787L10.2481 5.56711L14.7284 8.42548L14.7424 8.43436L14.7544 8.44654L17.4201 11.1348L20.4324 6.37854L16.7865 5.08091ZM14.1266 2.17907L15.6141 3.12116L15.7181 2.95698L14.2306 2.01489L14.1266 2.17907Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.3"
    />
  </svg>
);

export const widgetTradeTile: JSX.Element = (
  <svg
    data-slot="icon"
    fill="none"
    strokeWidth="1.5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.5 16.875h3.375m0 0h3.375m-3.375 0V13.5m0 3.375v3.375M6 10.5h2.25a2.25 2.25 0 0 0 2.25-2.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v2.25A2.25 2.25 0 0 0 6 10.5Zm0 9.75h2.25A2.25 2.25 0 0 0 10.5 18v-2.25a2.25 2.25 0 0 0-2.25-2.25H6a2.25 2.25 0 0 0-2.25 2.25V18A2.25 2.25 0 0 0 6 20.25Zm9.75-9.75H18a2.25 2.25 0 0 0 2.25-2.25V6A2.25 2.25 0 0 0 18 3.75h-2.25A2.25 2.25 0 0 0 13.5 6v2.25a2.25 2.25 0 0 0 2.25 2.25Z"
    ></path>
  </svg>
);

export const widgetPrice: JSX.Element = (
  <svg
    data-slot="icon"
    fill="none"
    strokeWidth="1.5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z"
    ></path>
  </svg>
);

export const widgetAnalytics: JSX.Element = (
  <svg
    data-slot="icon"
    fill="none"
    strokeWidth="1.5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.5 6a7.5 7.5 0 1 0 7.5 7.5h-7.5V6Z"
    ></path>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.5 10.5H21A7.5 7.5 0 0 0 13.5 3v7.5Z"
    ></path>
  </svg>
);

export const widgetSwapCurve: JSX.Element = (
  <svg
    data-slot="icon"
    fill="none"
    strokeWidth="1.5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 3v16.5A1.5 1.5 0 0 0 4.5 21H21M6.75 16.5c2.25-6 4.5-9 6.75-9s4.5 3 6.75 3"
    ></path>
  </svg>
);
export const widgetTradeFromScratch: JSX.Element = (
  <svg
    data-slot="icon"
    fill="none"
    strokeWidth="1.5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.5 14.25v4.5A1.5 1.5 0 0 1 18 20.25H6a1.5 1.5 0 0 1-1.5-1.5V5.25A1.5 1.5 0 0 1 6 3.75h6.75L19.5 10.5"
    ></path>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 12v6M9 15h6"></path>
  </svg>
);
// ---- END: ---- baseWidgetDetails: IbaseWidgetDetails[]

export const expandTableRows: JSX.Element = (
  <svg
    data-slot="icon"
    fill="none"
    strokeWidth="1.5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m4.5 5.25 7.5 7.5 7.5-7.5m-15 6 7.5 7.5 7.5-7.5"
    ></path>
  </svg>
);

export const collapseTableRows = `<svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" strokeWidth="1.5" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 18.75 7.5-7.5 7.5 7.5"></path>
<path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 7.5-7.5 7.5 7.5"></path>
</svg>`;

export const clearFilters = `<svg className="w-4 h-4" viewBox="0 0 75 75" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M52.7344 21.0938C49.6349 21.0902 46.5902 21.9115 43.913 23.4733C41.2357 25.0352 39.0223 27.2813 37.5 29.9812V18.75H32.8125V37.5H51.5625V32.8125H41.2891C42.3328 30.7761 43.9003 29.0547 45.8302 27.8253C47.7601 26.5959 49.9828 25.903 52.2695 25.8178C54.5561 25.7327 56.8241 26.2584 58.8401 27.3409C60.8561 28.4234 62.5473 30.0236 63.7395 31.9767C64.9317 33.9298 65.5819 36.1653 65.6232 38.4532C65.6645 40.7411 65.0954 42.9986 63.9745 44.9935C62.8536 46.9884 61.2214 48.6486 59.2458 49.8031C57.2702 50.9577 55.0226 51.565 52.7344 51.5625H51.5625V56.25H52.7344C57.3964 56.25 61.8674 54.398 65.164 51.1015C68.4605 47.8049 70.3125 43.3339 70.3125 38.6719C70.3125 34.0099 68.4605 29.5388 65.164 26.2423C61.8674 22.9457 57.3964 21.0938 52.7344 21.0938Z" fill="currentColor"/>
<path d="M60.9375 14.0625H9.375V21.4945L26.752 38.8718L28.125 40.2445V60.9375H37.5V56.25H42.1875V60.9375C42.1875 62.1807 41.6936 63.373 40.8146 64.2521C39.9355 65.1311 38.7432 65.625 37.5 65.625H28.125C26.8818 65.625 25.6895 65.1311 24.8104 64.2521C23.9314 63.373 23.4375 62.1807 23.4375 60.9375V42.1875L6.06047 24.8093C5.62516 24.374 5.27987 23.8572 5.04429 23.2885C4.80872 22.7197 4.68748 22.1101 4.6875 21.4945V14.0625C4.6875 12.8193 5.18136 11.627 6.06044 10.7479C6.93951 9.86886 8.1318 9.375 9.375 9.375H60.9375V14.0625Z" fill="currentColor"/>
</svg>
`;

export const userIcon = `<svg

    viewBox="0 0 70 70"
    fill="none"
    className="w-4 h-4"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.98 65.31C7.91 65.31 7.91 65.31 7.84 65.31C6.93 65.24 6.3 64.47 6.37 63.63C7.28 50.26 19.88 39.83 35 39.83C50.12 39.83 62.72 50.26 63.63 63.56C63.7 64.47 63 65.17 62.16 65.24C61.25 65.31 60.55 64.61 60.48 63.77C59.64 52.08 48.44 42.98 35 42.98C21.49 42.98 10.29 52.15 9.52 63.84C9.45 64.68 8.75 65.31 7.98 65.31Z"
      fill="currentColor"
    />
    <path
      d="M35 36.61C26.18 36.61 19.04 29.47 19.04 20.65C19.04 11.83 26.18 4.69 35 4.69C43.82 4.69 50.96 11.83 50.96 20.65C50.96 29.47 43.82 36.61 35 36.61ZM35 7.91C28 7.91 22.26 13.65 22.26 20.65C22.26 27.65 28 33.39 35 33.39C42 33.39 47.74 27.65 47.74 20.65C47.74 13.65 42 7.91 35 7.91Z"
      fill="currentColor"
    />
  </svg>`;

export const star = (
  <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" fill="#000000">
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        fill="yellow"
        d="M256 38.013c-22.458 0-66.472 110.3-84.64 123.502-18.17 13.2-136.674 20.975-143.614 42.334-6.94 21.358 84.362 97.303 91.302 118.662 6.94 21.36-22.286 136.465-4.116 149.665 18.17 13.2 118.61-50.164 141.068-50.164 22.458 0 122.9 63.365 141.068 50.164 18.17-13.2-11.056-128.306-4.116-149.665 6.94-21.36 98.242-97.304 91.302-118.663-6.94-21.36-125.444-29.134-143.613-42.335-18.168-13.2-62.182-123.502-84.64-123.502z"
      ></path>
    </g>
  </svg>
);

export const circleWithTick = (
  <svg
    data-slot="icon"
    fill="none"
    strokeWidth="1.5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    ></path>
  </svg>
);

export const circleWithCross = (
  <svg
    data-slot="icon"
    fill="none"
    strokeWidth="1.5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    ></path>
  </svg>
);

export const information = (
  <svg
    data-slot="icon"
    fill="none"
    strokeWidth="1.5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
    ></path>
  </svg>
);

export const question = (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="#8f8f8f"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 9C9 5.49997 14.5 5.5 14.5 9C14.5 11.5 12 10.9999 12 13.9999"
      stroke="#8f8f8f"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 18.01L12.01 17.9989"
      stroke="#8f8f8f"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const chevronDown = (
  <svg
    data-slot="icon"
    fill="none"
    strokeWidth="1.5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className="h-4 w-4"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m19.5 8.25-7.5 7.5-7.5-7.5"
    ></path>
  </svg>
);

export const chevronUp = (
  <svg
    data-slot="icon"
    fill="none"
    strokeWidth="1.5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className="h-4 w-4"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m4.5 15.75 7.5-7.5 7.5 7.5"
    ></path>
  </svg>
);

export const chevronRight = (
  <svg
    data-slot="icon"
    fill="none"
    strokeWidth="1.5"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className="h-4 w-4"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m8.25 4.5 7.5 7.5-7.5 7.5"
    ></path>
  </svg>
);
